import { withInstall } from '@jdesign-vue/utils'

import ColorPicker from './src/color-picker.vue'

export const JdColorPicker = withInstall(ColorPicker)
export default JdColorPicker

export * from './src/color-picker'
